export enum GenieActionKeys {
    INIT = '@@Genie/INIT',
}
